import { useState } from "react";
import type { FormEvent } from "react";
import { Link, useNavigate } from "react-router-dom";

export default function Hero() {
  const [keyword, setKeyword] = useState("");
  const navigate = useNavigate();

  const handleSearch = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const value = keyword.trim();
    navigate(value ? `/feed?q=${encodeURIComponent(value)}` : "/feed");
  };

  return (
    <section className="relative w-full overflow-hidden bg-foreground-950" aria-label="首屏品牌介绍">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Stylized%20abstract%20illustration%20of%20a%20city%20skyline%20at%20dusk%20with%20glowing%20amber%20and%20deep%20red%20window%20lights%2C%20flowing%20paper%20notes%20gliding%20through%20the%20dark%20sky%2C%20moody%20editorial%20poster%20art%2C%20dramatic%20contrast%2C%20deep%20maroon%20and%20gold%20palette%2C%20high%20detail&width=1600&height=900&seq=baoliao-hero-01&orientation=landscape"
          alt="夜晚城市众多亮灯窗口与新线索交织的抽象插画"
          title="爆料专区 - 匿名爆料与热点线索社区"
          className="h-full w-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/80 via-foreground-950/65 to-foreground-950/85" />
      </div>

      <div className="relative mx-auto flex w-full max-w-5xl flex-col items-center px-4 pb-20 pt-32 text-center md:px-8 md:pb-28 md:pt-44">
        <span className="inline-flex items-center gap-2 rounded-full border border-background-50/25 bg-background-50/10 px-4 py-1.5 font-label text-xs text-background-100 backdrop-blur">
          <i className="ri-flashlight-fill text-accent-400" aria-hidden="true" />
          今日新增 217 条线索 · 全程支持匿名投稿
        </span>

        <h2 className="mt-6 max-w-3xl text-balance font-display text-3xl font-bold leading-tight text-background-50 md:text-5xl">
          把你的见闻，变成更多人看得到的小事
        </h2>
        <p className="mt-5 max-w-2xl text-sm leading-relaxed text-background-200 md:text-base">
          身边的怪事、消费的坑、值得被记住的人，都可以在这里匿名说出来。
          投稿、私信、评论区留言三条通道全部开放，你的声音会被更多人看到。
        </p>

        <form
          onSubmit={handleSearch}
          role="search"
          className="mt-8 flex w-full max-w-xl flex-col gap-2 rounded-lg border border-background-50/20 bg-background-50/10 p-2 backdrop-blur sm:flex-row"
        >
          <label htmlFor="hero-search" className="sr-only">
            搜索爆料内容
          </label>
          <input
            id="hero-search"
            name="q"
            type="search"
            value={keyword}
            onChange={(event) => setKeyword(event.target.value)}
            placeholder="搜索关键词，例如：菜市场、加班、天台"
            className="w-full flex-1 rounded-md border-0 bg-background-50/95 px-4 py-2.5 text-sm text-foreground-900 outline-none placeholder:text-foreground-500 focus:ring-2 focus:ring-accent-400"
          />
          <button
            type="submit"
            className="inline-flex items-center justify-center whitespace-nowrap rounded-md bg-accent-500 px-5 py-2.5 font-label text-sm font-medium text-foreground-950 transition-colors hover:bg-accent-400"
          >
            <i className="ri-search-line mr-1.5" aria-hidden="true" />
            找爆料
          </button>
        </form>

        <div className="mt-8 flex flex-col items-center gap-3 sm:flex-row">
          <Link
            to="/submit"
            className="inline-flex w-full items-center justify-center whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 font-label text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 sm:w-auto"
          >
            <i className="ri-edit-2-line mr-2" aria-hidden="true" />
            我要爆料
          </Link>
          <Link
            to="/feed"
            className="inline-flex w-full items-center justify-center whitespace-nowrap rounded-md border border-background-50/40 px-6 py-3 font-label text-sm text-background-50 transition-colors hover:bg-background-50/10 sm:w-auto"
          >
            <i className="ri-compass-3-line mr-2" aria-hidden="true" />
            逛逛爆料广场
          </Link>
        </div>

        <dl className="mt-12 grid w-full max-w-2xl grid-cols-2 gap-x-4 gap-y-6 border-t border-background-50/15 pt-8 sm:grid-cols-4">
          {[
            { label: "累计爆料", value: "12,846" },
            { label: "今日新增", value: "217" },
            { label: "评论互动", value: "58,392" },
            { label: "活跃爆料人", value: "3,409" },
          ].map((stat) => (
            <div key={stat.label} className="flex flex-col items-center">
              <dt className="font-label text-xs text-background-300">{stat.label}</dt>
              <dd className="mt-1 font-display text-xl text-accent-400 md:text-2xl">{stat.value}</dd>
            </div>
          ))}
        </dl>
      </div>
    </section>
  );
}